/*
    App init client side
    @description:
        Everything in here will be resolved as soon as possible
        No matter if on client or server
    @author: Luca Margadant <luca.margadant@nueva.ch>
*/

export default defineNuxtPlugin(async (/* nuxtApp */) => {});
